// extracted by mini-css-extract-plugin
export default {"recos":"U4-z","productCardOverride":"V4-z","rowHasBadge":"W4-z"};